// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.network-failure-popup-backdrop {
  position: fixed;
  inset: 0;
  z-index: 20000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(0, 0, 0, 0.72);
}

.network-failure-popup {
  width: min(520px, 100%);
  border: 3px solid #f9d65c;
  border-radius: 18px;
  padding: 28px;
  background: #101725;
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.55);
  color: #ffffff;
  text-align: center;
}

.network-failure-popup-title {
  margin: 0 0 18px;
  color: #f9d65c;
  font-size: 1.8rem;
}

.network-failure-popup-message {
  margin: 0;
  white-space: pre-line;
  font-size: 1.1rem;
  line-height: 1.55;
}

.network-failure-popup-exit-button {
  margin-top: 28px;
  border: none;
  border-radius: 999px;
  padding: 14px 38px;
  background: #f04b4b;
  color: #ffffff;
  cursor: pointer;
  font-size: 1.15rem;
  font-weight: 700;
}

.network-failure-popup-exit-button:hover {
  background: #ff6262;
}

.network-failure-popup-exit-button:focus-visible {
  outline: 3px solid #ffffff;
  outline-offset: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/components/NetworkFailurePopup.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB","sourcesContent":[".network-failure-popup-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 20000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  background: rgba(0, 0, 0, 0.72);\n}\n\n.network-failure-popup {\n  width: min(520px, 100%);\n  border: 3px solid #f9d65c;\n  border-radius: 18px;\n  padding: 28px;\n  background: #101725;\n  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.55);\n  color: #ffffff;\n  text-align: center;\n}\n\n.network-failure-popup-title {\n  margin: 0 0 18px;\n  color: #f9d65c;\n  font-size: 1.8rem;\n}\n\n.network-failure-popup-message {\n  margin: 0;\n  white-space: pre-line;\n  font-size: 1.1rem;\n  line-height: 1.55;\n}\n\n.network-failure-popup-exit-button {\n  margin-top: 28px;\n  border: none;\n  border-radius: 999px;\n  padding: 14px 38px;\n  background: #f04b4b;\n  color: #ffffff;\n  cursor: pointer;\n  font-size: 1.15rem;\n  font-weight: 700;\n}\n\n.network-failure-popup-exit-button:hover {\n  background: #ff6262;\n}\n\n.network-failure-popup-exit-button:focus-visible {\n  outline: 3px solid #ffffff;\n  outline-offset: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
